/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../$$_gendir/node_modules/ngx-progressbar/index.ngfactory';
import * as i2 from 'ngx-progressbar';
import * as i3 from '@angular/router';
import * as i4 from '../../app/app.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ng-progress',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_ɵa_0,i1.RenderType_ɵa)),
      i0.ɵdid(1,704512,(null as any),0,i2.ɵa,[i2.NgProgressService],{ease:[0,'ease'],
          positionUsing:[1,'positionUsing'],direction:[2,'direction'],color:[3,'color'],
          thick:[4,'thick'],trickleSpeed:[5,'trickleSpeed']},(null as any)),(_l()(),
          i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵeld(3,16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(4,212992,(null as any),
          0,i3.RouterOutlet,[i3.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any))],
      (_ck,_v) => {
        const currVal_0:any = 'easeInSine';
        const currVal_1:any = 'marginLeft';
        const currVal_2:any = 'leftToRightIncreased';
        const currVal_3:any = '#4286f4';
        const currVal_4:any = true;
        const currVal_5:any = 500;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
        _ck(_v,4,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'body',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,49152,(null as any),0,i4.AppComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i4.AppComponent> = i0.ɵccf('body',
    i4.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Tb3VyY2UvZVNvZnRDZXJlYWwuQVBJL2VTb2Z0Q2VyZWFsLlVJL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5nLXByb2dyZXNzXHJcbltwb3NpdGlvblVzaW5nXT1cIidtYXJnaW5MZWZ0J1wiXHJcbltkaXJlY3Rpb25dPVwiJ2xlZnRUb1JpZ2h0SW5jcmVhc2VkJ1wiXHJcbltjb2xvcl09XCInIzQyODZmNCdcIlxyXG5bdHJpY2tsZVNwZWVkXT1cIjUwMFwiIFxyXG5bdGhpY2tdPVwidHJ1ZVwiIFxyXG5bZWFzZV09XCInZWFzZUluU2luZSdcIlxyXG4+PC9uZy1wcm9ncmVzcz5cclxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiIsIjxib2R5PjwvYm9keT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUE7VUFBQTtVQUFBLGtFQU9lO2lCQUFBLDJCQUNmO1VBQUE7VUFBQSxtREFBQTtVQUFBO2NBQUE7O1FBRkE7UUFMQTtRQUNBO1FBQ0E7UUFFQTtRQURBO1FBSkEsV0FNQSxVQUxBLFVBQ0EsVUFDQSxVQUVBLFVBREEsU0FKQTtRQVFBOzs7O29CQ1JBO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/$$_gendir/app/app.component.ngfactory.ts